import { css } from '@emotion/css';

export const ratingOverrides = {
  iconEmpty: 'group-hover:text-icon-placeholder text-transparent',
  icon: 'transform-none',
};

export const ratingCellInputStyles = css`
  .MuiInputBase-root {
    border-radius: 0.4rem;
  }
`;
